export default __webpack_public_path__ + "static/pious-7ee3a7fc9b4735e2a46db90143efcb06.svg";